export const scoreConfig = [
  { minScore: 0, color: '#079514', textId: 'screenings.results.adult.ucla3.not-lonely' },
  { minScore: 5, color: '#E4EB00', textId: 'screenings.results.adult.ucla3.approaching-loneliness' },
  { minScore: 6, color: '#E19D34', textId: 'screenings.results.adult.ucla3.mild-loneliness' },
  { minScore: 7, color: '#E15834', textId: 'screenings.results.adult.ucla3.moderate-loneliness' },
  { minScore: 9, color: '#B64B45', textId: 'screenings.results.adult.ucla3.acute-loneliness' },
];
